import AddIcon from "@mui/icons-material/Add";
import { Chip, IconButton, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { RiContactsBook3Fill } from "react-icons/ri";

import TableHeadings from "../../components/Common-components/table-headings";
import { Pagination } from "../../components/Pagination";
import CustomModal from "../../components/PopUpModal";
import DeleteModal from "../../components/Modal/delete-modal";
import FormField from "../../components/Common-components/form-input";

import { Modal } from "react-bootstrap";
import { Spinner } from "../../components/Common-components/spinner";
import { useTranslation } from "react-i18next";
import SearchFilter from "../../components/Common-components/serchFillter";
import { useCheckPermission } from "../../hooks/useCheckPermission";
import NoPermissionMessage from "../../components/Common-components/noPermissionMessage";
import moment from "moment-timezone";

import useVersion from "./hook/useVersion";
import useMuiCustom from "../../hooks/useMuiCustom";
import { Label } from "@mui/icons-material";

const Version = () => {
  const { t } = useTranslation();
  const { data, method } = useVersion();
  const {
    controller,
    loader,
    totalCount,
    anchorEl,
    openModal,
    versionList,
    openMenu,
    formData,
  } = data;

  const {
    TableHeadData,
    handlePagination,
    handleClosedModal,
    handleOpenModal,
    handleClickMenu,
    setAnchorEl,
    handleCloseMenu,
    handleChange,
    versionUpdate,
  } = method;

  const { StyledMenu } = useMuiCustom();

  return (
    <>
      <div className="container-fluid d-flex flex-column h-100">
        <div className="px-2">
          <h1 className="font-18 black-color pb-2">
            {`${t("sideBar.version")}`}
          </h1>
        </div>

        <div className="table-responsive custom_table flex-fill mt-3 custom_scroll px-2">
          <table className="table cus-table">
            <TableHeadings
              TableHeadData={TableHeadData}
              controller={controller}
              setController={handlePagination}
            />

            <tbody>
              {versionList?.map((item, index) => (
                <tr key={item._id}>
                  <td>
                    {controller?.rowsPerPage * (controller?.page - 1) +
                      index +
                      1}
                  </td>
                  <td className="blue-color cursor">{item?.project}</td>
                  <td>{item?.type}</td>
                  <td>{item?.version}</td>

                  <td className="cursor">
                    <IconButton
                      sx={{ width: "10px", height: "10px" }}
                      size="small"
                      id={`menu-btn-${index}`}
                      aria-controls={
                        openMenu && anchorEl.index === index
                          ? `menu-${index}`
                          : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={
                        openMenu && anchorEl.index === index
                          ? "true"
                          : undefined
                      }
                      variant="contained"
                      disableElevation
                      onClick={(event) => handleClickMenu(event, index)}
                    >
                      <MoreVertIcon />
                    </IconButton>

                    <StyledMenu
                      id={`menu-${index}`}
                      MenuListProps={{ "aria-labelledby": `menu-btn-${index}` }}
                      anchorEl={
                        anchorEl.index === index ? anchorEl.element : null
                      }
                      open={openMenu && anchorEl.index === index}
                      onClose={() =>
                        setAnchorEl({ element: null, index: null })
                      }
                    >
                      <MenuItem
                        onClick={() => handleCloseMenu(versionList[index])}
                      >
                        {t("buttonTitle.update")}
                      </MenuItem>
                    </StyledMenu>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {totalCount > 10 && (
          <Pagination
            count={totalCount}
            controller={controller}
            setController={handlePagination}
          />
        )}

        {/* UPDATE MODAL */}
        <Modal
          size="md"
          show={openModal.edit}
          onHide={() => handleClosedModal("edit")}
          centered
        >
          <Modal.Body>
            <h5 className="mb-3">Update Version</h5>

            <div className="row">
              <div className="col-md-6 col-12 mb-3">
                <label>{t("tableTitle.project")}</label>
                <FormField
                  disabled
                  value={formData.project}
                  name="project"
                  placeholder="Enter Project"
                  onChange={handleChange}
                  className="bg-secondary bg-opacity-25"
                />
              </div>

              <div className="col-md-6 col-12 mb-3">
                <label>{t("formTitle.deviceType")}</label>
                <FormField
                  disabled
                  value={formData.type}
                  name="type"
                  placeholder="Device Type"
                  onChange={handleChange}
                   className="bg-secondary bg-opacity-25"
                />
              </div>

              <div className="col-md-6 col-12 mb-3">
                <label>{t("sideBar.version")}</label>
                <FormField
                  value={formData.version}
                  name="version"
                  placeholder="Version Number"
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-secondary me-2"
                onClick={() => handleClosedModal("edit")}
              >
                Cancel
              </button>

              <button className="btn btn-primary" onClick={versionUpdate}>
                Update
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Version;
